/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import Header from "../header"
import Footer from "../footer"
// import RequestQuote from "../request-a-quote"
// import SSRProvider from 'react-bootstrap/SSRProvider';

const Layout = ({ children, headerClass }) => {
    return (
        <div className="wrapper">
            <div className={`transparent-header ${headerClass}`}>
                <Header />
            </div>            
            <main className="main-container">
                {children}
                {/* <RequestQuote /> */}
            </main>
            <Footer />
        </div>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    headerClass: PropTypes.string
}

export default Layout
